<template>
  <div class="lmap-container map-container">
    <l-map
      ref="map"
      class="fmap"
      :zoom="zoom"
      :center="center"
      :bounds="bounds"
      :useGlobalLeaflet="false"
      :options="{ attributionControl: false }"
       @ready="onMapReady"
    >
      <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <l-marker v-for="marker in locations" :key="marker.id" :lat-lng="[marker.lat, marker.lng]" :options="{ opacity: markerOpacity }" />
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LGeoJson } from "@vue-leaflet/vue-leaflet";
import 'leaflet/dist/leaflet.css';
export default {
  name: 'LeafletMap',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LGeoJson
  },
  props: {
    locations: [],
    polylines: [],
    heatdata: [],
    maptype: ''
  },
  data() {
    return {
      zoom: 10,
      center: [0, 0],
      markers: [],
      bounds: null,
      mapInstance: null,
      markerOpacity: 1
    };
  },
  methods: {
    updateMapBounds() {
      if (this.locations.length > 0) {
        const latLngs = this.locations.map(marker => [marker.lat, marker.lng]);
        this.bounds = latLngs;
        this.$nextTick(() => {
          this.mapInstance = this.$refs.map.mapObject;
          if(this.mapInstance) {
            this.mapInstance.fitBounds(this.bounds, { padding: [75, 75] });
          }
        });
      }
    },
    onMapReady(mapObject) {
        this.mapInstance = mapObject;
        this.mapInstance.fitBounds(this.locations.map(marker => [marker.lat, marker.lng]));

         // start listeners
        this.mapInstance.on('zoomend', () => {
          console.log('Map zoom ended. Current map boundaries:', this.mapInstance.getBounds());
          alert('Map zoom ended. Current map boundaries: ' + JSON.stringify(this.mapInstance.getBounds()));
        });

        this.mapInstance.on('dragend', () => {
          console.log('Map drag ended. Current map boundaries:', this.mapInstance.getBounds());
          alert('Map drag ended. Current map boundaries: ' + JSON.stringify(this.mapInstance.getBounds()));
        });
        // end listeners
    }
  },
  watch: {
    locations: {
      handler: 'updateMapBounds',
      deep: true
    }
  },
  mounted() {
    console.log('test location data '+JSON.stringify(this.locations));
    // test passed Data
    console.log('Markers selected');
  }
};
</script>